import React from 'react';
import { motion } from 'framer-motion';
export function SalesLetter() {
  return <section className="pt-2 pb-8 px-4 bg-transparent" data-id="element-206">
      <div className="max-w-2xl mx-auto" data-id="element-207">
        <div className="text-center" data-id="element-208">
          <img src="https://cdn.magicpatterns.com/uploads/urUk3ruxVL3k4gSwC8BthM/IMG_8849.jpg" alt="Garantía de 7 días para tu pack de kit imprimible" className="w-full max-w-md mx-auto rounded-2xl shadow-card mb-10" data-id="element-209" />
          <h3 className="text-2xl md:text-3xl font-heading font-semibold text-secondary mb-4 tracking-tight leading-snug" data-id="element-210">
            Miles de mamás empezaron igual que vos..
            <br data-id="element-211" />
            buscando algo lindo para el cumple de su hijo.
          </h3>
          <p className="text-base md:text-lg text-body/90 leading-[1.8] mb-8 max-w-xl mx-auto" data-id="element-212">
            Terminaron con un emprendimiento propio, clientas fijas y dinero
            extra todos los meses.
            <br data-id="element-213" />
            <span className="font-bold text-dark mt-2 inline-block" data-id="element-214">
              👇 Mirá todo lo que viene adentro:
            </span>
          </p>

          <div className="inline-block bg-primary/10 text-primary font-semibold text-base px-6 py-3 rounded-full mb-8" data-id="element-215">
            Más de 10.000 diseños listos para usar
          </div>

          <div className="w-full max-w-sm mx-auto rounded-3xl overflow-hidden shadow-card border-4 border-white" data-id="element-216">
            <video src="https://cdn.magicpatterns.com/uploads/39geuhwnSqrAqApUas1rjB/Gray%20and%20Black%20Modern%20Handphone%20Mockup%20Instagram%20Story%20(1).mp4" autoPlay loop muted playsInline className="w-full h-auto" data-id="element-217" />
          </div>
        </div>
      </div>
    </section>;
}